import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import SearchItem from './SearchItem';

const BunnyKlawzSearchItem = ({ selectedSite, setSelectedSite }) => {
    const location = useLocation();
    const navigate = useNavigate();

    return (
        <SearchItem
            imageSrc='/images/BunnyKlawzIcon.png'
            title='BunnyKlawz'
            url='https://bunnyklawz.com'
            description='Book a custom nail session with BunnyKlawz in Phoenix, AZ.'
            onClick={() => {
                setSelectedSite('bunny');
                navigate(`/portfolio/bunny`);
            }}
        />
    );
};

export default BunnyKlawzSearchItem;
